import { GtmEvent } from '../../enum/gtm-event';
import { GtmAction } from '../gtm-action';
import { GtmVariableKey } from '../gtm-variable-key';
import { GtmVariables } from '../gtm-variables';

export type VirtualPageViewGtmActionPayload = Pick<GtmVariables, GtmVariableKey.pathname>;

export class VirtualPageViewGtmAction implements GtmAction {
    event = GtmEvent.virtual_page_view;

    constructor(public payload: VirtualPageViewGtmActionPayload) {}
}
